class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.scrollPosition = null;
    this.scrollPreventionActive = false;
    
    // Prevent scroll when clicking to open mega menu
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) {
      // Store scroll position before any interaction
      summary.addEventListener('mousedown', (event) => {
        if (!this.mainDetailsToggle.hasAttribute('open')) {
          this.scrollPosition = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
          this.scrollPreventionActive = true;
        }
      }, { passive: false });
      
      // Prevent scroll on click without preventing default (so menu still opens)
      summary.addEventListener('click', (event) => {
        if (!this.mainDetailsToggle.hasAttribute('open')) {
          // Store scroll position
          this.scrollPosition = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
          this.scrollPreventionActive = true;
          
          // Don't prevent default - let the menu open naturally
          // But immediately start preventing scroll
          this.preventScroll();
        }
      }, { passive: true });
    }
    
    // Also prevent scroll on toggle event
    this.mainDetailsToggle.addEventListener('toggle', () => {
      if (this.mainDetailsToggle.hasAttribute('open') && this.scrollPreventionActive) {
        this.preventScroll();
      } else if (!this.mainDetailsToggle.hasAttribute('open')) {
        // Clean up when menu closes
        this.scrollPreventionActive = false;
        if (this.scrollListener) {
          window.removeEventListener('scroll', this.scrollListener, { capture: true });
          this.scrollListener = null;
        }
      }
    });
  }
  
  preventScroll() {
    if (this.scrollPosition === null) return;
    
    // Immediately restore scroll position
    const restoreScroll = () => {
      if (!this.scrollPreventionActive) return;
      const currentScroll = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
      if (Math.abs(currentScroll - this.scrollPosition) > 1) {
        window.scrollTo({ top: this.scrollPosition, behavior: 'instant' });
      }
    };
    
    // Add scroll listener to actively prevent scrolling
    if (!this.scrollListener) {
      this.scrollListener = () => {
        if (this.scrollPreventionActive) {
          restoreScroll();
        }
      };
      window.addEventListener('scroll', this.scrollListener, { passive: false, capture: true });
    }
    
    // Restore multiple times to catch any delayed scrolls
    restoreScroll();
    requestAnimationFrame(() => {
      restoreScroll();
      requestAnimationFrame(() => {
        restoreScroll();
        setTimeout(() => {
          restoreScroll();
          // Keep prevention active for a bit longer
          setTimeout(() => {
            this.scrollPreventionActive = false;
            if (this.scrollListener) {
              window.removeEventListener('scroll', this.scrollListener, { capture: true });
              this.scrollListener = null;
            }
          }, 200);
        }, 100);
      });
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
    
    // Prevent scroll when opening
    if (this.mainDetailsToggle.hasAttribute('open') && this.scrollPreventionActive) {
      this.preventScroll();
    }
  }
}

customElements.define('header-menu', HeaderMenu);
